<template>
	<div>
		<div style="text-align: left; padding-bottom: 10px;">
			<el-col :span="6">	
				<el-button type="primary" @click="goodsUpdate">添加商品</el-button>		
			</el-col>
			
		</div>
		<el-table :data="tableData" style="width: 100%" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
      		<el-table-column prop="name" label="商品名称" width="180"></el-table-column>
      		<el-table-column prop="price" label="商品价格" width="180"></el-table-column>
      		<el-table-column prop="detail" label="商品描述" width="160"></el-table-column>
      		<el-table-column prop="state" label="状态" width="180">
	      			<template slot-scope="scope">
      				<el-tag v-if="scope.row.state==0" type="danger">无效</el-tag>
      				<el-tag v-if="scope.row.state==1" type="success">有效</el-tag>
      			</template>
      		</el-table-column>	
      		<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
      		<el-table-column label="操作" width="250">
      			<template scope="scope">
					<el-button size="small" v-if="scope.row.state==0" @click="visibleGoods(scope.$index, scope.row)">置为有效</el-button>
					<el-button size="small" v-if="scope.row.state==1" @click="visibleGoods(scope.$index, scope.row)">置为无效</el-button>
					<el-button size="small" @click="goodsUpdate(scope.$index, scope.row)">修改</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		
	</div>

	
</template>
<script >
	import {getGoodsList,visibleGoods} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		total:0,
		 		pageCount:0,
		 		companyName:''
		 	}
		},
		created:function() {
			var _this = this;
			let params = {pageNum:0,pageSize:this.pageSize};
			getGoodsList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
			});
			
		},
		methods:{
			searchLine(){
				this.reload();
			},
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getGoodsList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
				});
			},
			goodsUpdate(index,row){
				var param={};
				if(row){
					param.id = row.id;
				}
				this.$router.push({name:"goodsUpdate",query:param});
			},
			reload(){
				console.log("reload");
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,companyName:this.companyName};
				getGoodsList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			visibleGoods(index,row){
				let _this = this;
				let params={id:row.id};
				if(row.state==1){
					params.state=0;
				}else{
					params.state=1;
				}
				visibleGoods(params).then(res=>{
					if(res.data.status=='success'){
						this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
						_this.reload();
					}
				});
			}
		}
	}
</script>